import React from "react";
import "./assets/styles/App.css";
import NdleLogo from "./assets/img/NdleLogo.gif";

function App(){
    return(
        <div className="main-wrapper">
            <div className="launch-wrapper">
                <div className="img-logo-wrapper">
                    <img src={NdleLogo}/>
                </div>
                <h1>CRAFTING <span>SOON!</span></h1>
                <p>We're thrilled to take ndle. to the next level 🥹</p>
            </div>
        </div>
    )
}
export default App;